import Modulos from '@/classes/enums/Modulos'

export default [
  {
    path: 'companies',
    name: 'companies',
    component: () => import('@/views/companies/Companies.vue'),
    meta: { registerNavFromMenu: true }
  },
  {
    path: 'companies/:id/details',
    name: 'companies/detail',
    component: () => import('@/views/companies/Company.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  // {
  //   path: 'companies/:id/configtransf',
  //   name: 'companies/configtransf',
  //   component: () => import('@/views/companies/ConfigTransformador.vue'),
  //   meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  // },
  {
    path: 'companies/:id/config',
    name: 'companies/config',
    component: () => import('@/views/companies/Config.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  {
    path: 'companies/:id/pgeconfig',
    name: 'companies/pgeconfig',
    component: () => import('@/views/companies/PGEConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, modules: [[Modulos.RECEPCION_FACTURAS]] }
  },
  {
    path: 'companies/:id/apsconfig',
    name: 'companies/apsconfig',
    component: () => import('@/views/companies/APSConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, modules: [[Modulos.RECEPCION_FACTURAS], [Modulos.INTEGRACION_OCR]] }
  },
  {
    path: 'companies/:id/reportconfig',
    name: 'companies/reportconfig',
    component: () => import('@/views/companies/ReportConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, modules: [[Modulos.EMISION_FACTURAS], [Modulos.VERIFACTU, Modulos.TICKETBAI_BATUZ]] }
  },
  {
    path: 'companies/:id/pdftemplate',
    name: 'companies/pdftemplate',
    component: () => import('@/views/companies/XsltTemplateConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, modules: [[Modulos.GENERACION_FACTURAS_PDF]] }
  },
  {
    path: 'companies/:id/historical',
    name: 'companies/historical',
    component: () => import('@/views/historical/CompanyHistorical.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  }
]
